import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing.x2};
`;

export const PagerContainerText = styled.div`
  color: ${({ theme }) => theme.palette.lightGray};
  min-width: max-content;
`;

export const PagerContainerTextSpan = styled.span`
  color: ${({ theme }) => theme.palette.lightGray};
`;

export const PagerContainerBtn = styled.div`
  margin-inline-start: ${({ theme }) => theme.spacing.x2};
`;

export const PagerContainerBtnIcon = styled.button<{ $disable? }>`
  cursor: pointer;
  color: ${({ theme }) => theme.palette.lightGray};
  border: none;
  background: transparent;
  &:last-child {
    margin-inline-start: ${({ theme }) => theme.spacing.x1};
  }
  ${({ $disable }) =>
    $disable
      ? css`
          color: ${({ theme }) => theme.palette.lightestGray};
          cursor: no-drop;
        `
      : null}
`;

export const PagerContainerBtnSvg = styled.div`
  font-size: ${({ theme }) => theme.fs.xxxl};
`;
